import React, { useState } from 'react';
import { FaCalendarAlt, FaMapMarkerAlt, FaSearch } from 'react-icons/fa';
import HeadingWithWatermark from '../component/HeadingWithWatermark';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';

// Theme colors
const primaryBlue = 'rgb(43, 147, 208)';
const yellowAccent = '#fbbf24';

// Data for past ICSME conferences
const pastConferences = [
  { number: 28, theme: 'Innovative Pathways for Sustainable SME Growth: Bridging Global Opportunities', venue: 'Riyadh, Saudi Arabia', date: 'Sept. 20, 2024' },
  { number: 27, theme: 'Empowering SMEs for Global Growth and Sustainability: Unlocking Credit, Technology, and Market Access', venue: 'Dubai, UAE', date: 'Dec. 9, 2023' },
  { number: 26, theme: 'Recurrent Emergencies. Resilient Enterprise. Envisioning the Future', venue: 'Johannesburg, South Africa', date: 'Nov. 30 – Dec. 2, 2022' },
  { number: 25, theme: 'SMEs: Key to an inclusive and sustainable recovery Post Pandemic through Atmanirbhar Bharat', venue: 'Virtual, India', date: 'Dec. 11, 2021' },
  { number: 24, theme: 'Risk, Resilience and Rebalancing Business Post Covid 19', venue: 'Virtual, India', date: 'Dec. 8, 2020' },
  { number: 23, theme: 'Achieving inclusive and sustainable Goal through SME 4.0', venue: 'Delhi-NCR, India', date: 'Dec. 17–18, 2019' },
  { number: 22, theme: 'Achieving inclusive and sustainable growth through Entrepreneurship Education and innovation by promoting SME’s', venue: 'Dubai, UAE', date: 'Dec. 9–10, 2018' },
  { number: 21, theme: 'Achieving inclusive and sustainable industrialization by promoting SME', venue: 'India', date: 'Nov. 30 – Dec. 1, 2017' },
  { number: 20, theme: 'Globalisation of SMEs: Challenges and Opportunities for SMES', venue: 'Yenagoa, Nigeria', date: 'Apr. 29 - May 3, 2014' },
  { number: 19, theme: 'Beyond The Downturn – Revitalizing The Global Economy Through Small And Medium Enterprises', venue: 'Durban, South Africa', date: 'Sept 18-21, 2013' },
  { number: 18, theme: 'Making SMEs globally competitive :The Challenge and the way forward', venue: 'Colombo, Sri Lanka', date: 'Nov. 1-3, 2007' },
  { number: 17, theme: 'Hand in Hand for Small Business', venue: 'Seoul, South Korea', date: 'April 26-30, 2006' },
  { number: 16, theme: 'To prepare SMEs for Knowledge-based economy', venue: 'Bucharest, Romania', date: 'May 15-18, 2005' },
  { number: 15, theme: 'Promoting SMEs for Global Competitiveness', venue: 'Abuja, Nigeria', date: 'July 19-22, 2004' },
  { number: 14, theme: 'Opportunities for SMEs in a globalised world: Innovative policies and programmes', venue: 'Tel-Aviv, Israel', date: 'Sept.15-18, 2003' },
  { number: 13, theme: 'The main focus was on developing global strategies to assist SMEs', venue: 'Gibraltar, UK', date: 'Apr. 7-10, 2002' },
  { number: 12, theme: 'New Economic Approaches for Developing SMEs and Encouraging Entrepreneurship Worldwide', venue: 'Antalya, Turkey', date: 'Apr.23-25, 2001' },
  { number: 11, theme: 'Coincided with the Process of Reforms and SMEs as the Backbone of Economy Worldwide', venue: 'Mumbai, India', date: 'March 10-12, 1999' },
  { number: 10, theme: 'The role of SMEs in Promoting Economic Development in the New Millennium', venue: 'Miami, Florida, USA', date: 'Apr 6-9, 1997' },
  { number: 9, theme: 'Enhancing Global Competitiveness of SMEs', venue: 'New Delhi, India', date: 'Apr. 17-19, 1996' },
  { number: 8, theme: 'A Strategy for Financing and Management of SMEs in Developing Countries', venue: 'Cairo, Egypt', date: 'April 10-13, 1995' },
  { number: 7, theme: 'Challenges and Opportunities for SMEs in the New Global Economic Environment', venue: 'Addis Ababa, Ethiopia', date: 'March 9-11, 1994' },
  { number: 6, theme: 'Enhancing Global Cooperation for SMEs', venue: 'Seoul, Korea', date: 'Apr. 23-25, 1992' },
  { number: 5, theme: 'SMEs for sustained growth and vitalisation of economies', venue: 'Moscow, Russia', date: 'Nov. 13-16, 1991' },
  { number: 4, theme: 'Financing of SMEs in Developing Countries', venue: 'Belgrade, Yugoslavia', date: 'June 9-11, 1988' },
  { number: 3, theme: 'Management of Business Activities and Development of SMEs in Developing Countries', venue: 'Belgrade, Yugoslavia', date: 'Sept. 17-19, 1987' },
  { number: 2, theme: 'Technical and Technological Development and Marketing of SMEs in Developing Countries', venue: 'Belgrade, Yugoslavia', date: 'Sept. 11-13, 1986' },
  { number: 1, theme: 'SMEs – A Vital Factor in the Developing of Development Countries', venue: 'Belgrade, Yugoslavia', date: 'Sept.17-19, 1985' },
];

const ICSMEPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredConferences, setFilteredConferences] = useState(pastConferences);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    const filtered = pastConferences.filter(
      (conf) =>
        conf.theme.toLowerCase().includes(term) ||
        conf.venue.toLowerCase().includes(term) ||
        conf.date.toLowerCase().includes(term) ||
        conf.number.toString().includes(term)
    );
    setFilteredConferences(filtered);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
     
    
     <Navbar/>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-4">
              <HeadingWithWatermark
          title="ICSME Conferences"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
          
        />
              
          <p className="text-lg text-gray-600 max-w-7xl mx-auto leading-relaxed text-justify">
            The annual ICSME is a prestigious event that brings together business support organisations, policymakers, banks and financial institutions, international experts, academics, entrepreneurs, the United Nations, and other international and multi-national aid agencies concerned with small business development.
          </p>
          <p className="text-lg text-gray-600 max-w-7xl mx-auto mt-4 leading-relaxed text-justify">
            This is a fantastic venue for exchanging knowledge, experience, and developing best practises, as well as making new contacts and forging commercial connections. The conference provides an excellent opportunity for networking and business development, and is an essential event for anyone involved in small and medium enterprises.
          </p>
        </div>

        {/* Search Bar */}
        <div className="max-w-xl mx-auto mb-8">
          <div className="relative">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search by theme, venue, year, or edition..."
              value={searchTerm}
              onChange={handleSearch}
              className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[rgb(43,147,208)] focus:border-transparent shadow-sm"
            />
          </div>
        </div>

        {/* Past Conferences Table (desktop) / Cards (mobile) */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-700">
              <thead className="text-xs uppercase tracking-wider" style={{ backgroundColor: primaryBlue, color: 'white' }}>
                <tr>
                  <th scope="col" className="px-6 py-4">Edition</th>
                  <th scope="col" className="px-6 py-4">Theme</th>
                  <th scope="col" className="px-6 py-4">Venue</th>
                  <th scope="col" className="px-6 py-4">Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredConferences.length > 0 ? (
                  filteredConferences.map((conf, index) => (
                    <tr
                      key={conf.number}
                      className={`border-b border-gray-200 hover:bg-blue-50 transition-colors ${
                        index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                      }`}
                    >
                      <td className="px-6 py-4 font-medium whitespace-nowrap">
                        <span
                          className="px-2 py-1 rounded-full text-xs font-semibold"
                          style={{ backgroundColor: yellowAccent + '30', color: '#1e3a8a' }}
                        >
                          {conf.number}
                          {conf.number === 1 ? 'st' : conf.number === 2 ? 'nd' : conf.number === 3 ? 'rd' : 'th'} ICSME
                        </span>
                      </td>
                      <td className="px-6 py-4 max-w-md">{conf.theme}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <FaMapMarkerAlt className="mr-2 text-gray-400" style={{ color: primaryBlue }} />
                          {conf.venue}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <FaCalendarAlt className="mr-2 text-gray-400" style={{ color: primaryBlue }} />
                          {conf.date}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="px-6 py-8 text-center text-gray-500">
                      No conferences match your search.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

     
      </main>

   <Footer/>
    </div>
  );
};

export default ICSMEPage;